module.exports = __webpack_public_path__ + "public/img/bannar-chengguo.10577928.png";